import { fromIndex } from "../i18n";


export const RouteKeys = {
	HOME: "home",
	CORPORATE_LIST: "corporatelist",
	TEST: "test",
	REPORT: "report",
	ACCOUNT: "account",
	SETTING: "setting",

	COUNSELING:"counseling",
	COUNSELING_OVERVIEW: "counseling_overview",
	COUNSELING_BY_PROVIDER:"counseling_by_provider",
	COUNSELING_BY_PLATFORM:"counseling_by_platform",
	COUNSELING_BY_TOPIC:"counseling_by_topic",
	COUNSELING_BY_AGE:"counseling_by_age",
	COUNSELING_BY_GENDER:"counseling_by_gender",
	COUNSELING_BY_USER_RETENTION:"counseling_by_user_retention",
	COUNSELING_BY_FEEDBACK:"counseling_by_feedback",
	COUNSELING_BY_VISIT_OUTCOME:"counseling_by_visit_outcome",

	STRESS_TEST: "stress",
	STRESS_USAGE_OVERVIEW:"stress_usage_overview",
	STRESS_INDIVIDUAL_QUESTION: "stress_individual_question",
	STRESS_BY_LEVEL:"stress_by_level",
	STRESS_BY_AGE:"stress_by_age",
	STRESS_BY_GENDER:"stress_by_gender",
	STRESS_BY_DEPARTMENT:"stress_by_department",
	STRESS_BY_RETURNING:"stress_by_returning",

	PEOPLE: "people",
	PEOPLE_OVERVIEW: "people_overview",
	INDIVIDUAL_USER: "individual_user",

	// PLAYGROUND:"playground",
};

export const STRESS_TEST_REPORT_MENU = `${RouteKeys.REPORT}/${RouteKeys.TEST}/${RouteKeys.STRESS_TEST}`;
export const COUNSELING_TEST_REPORT_MENU = `${RouteKeys.REPORT}/${RouteKeys.COUNSELING}`;

export const AttrRouteFormat = {
	STRESS:"stress_by_{0}",
	COUNSELING:"coun_by_{0}",
	PEOPLE:"people_by_{0}",
};
export const SiderRouteFormat = {
	STRESS:`${STRESS_TEST_REPORT_MENU}/{0}`,
	COUNSELING:`${COUNSELING_TEST_REPORT_MENU}/{0}`
};

export const SiderPath = {
	[RouteKeys.HOME]: RouteKeys.HOME,
	[RouteKeys.CORPORATE_LIST]: RouteKeys.CORPORATE_LIST,
	[RouteKeys.REPORT]: RouteKeys.REPORT,
	[RouteKeys.ACCOUNT]: RouteKeys.ACCOUNT,
	[RouteKeys.SETTING]: RouteKeys.SETTING,

	[RouteKeys.COUNSELING_OVERVIEW]: fromIndex(SiderRouteFormat.COUNSELING, RouteKeys.COUNSELING_OVERVIEW),
	[RouteKeys.COUNSELING_BY_PROVIDER]: fromIndex(SiderRouteFormat.COUNSELING, RouteKeys.COUNSELING_BY_PROVIDER),
	[RouteKeys.COUNSELING_BY_PLATFORM]: fromIndex(SiderRouteFormat.COUNSELING, RouteKeys.COUNSELING_BY_PLATFORM),
	[RouteKeys.COUNSELING_BY_TOPIC]: fromIndex(SiderRouteFormat.COUNSELING, RouteKeys.COUNSELING_BY_TOPIC),
	[RouteKeys.COUNSELING_BY_AGE]: fromIndex(SiderRouteFormat.COUNSELING, RouteKeys.COUNSELING_BY_AGE),
	[RouteKeys.COUNSELING_BY_GENDER]: fromIndex(SiderRouteFormat.COUNSELING, RouteKeys.COUNSELING_BY_GENDER),
	[RouteKeys.COUNSELING_BY_USER_RETENTION]: fromIndex(SiderRouteFormat.COUNSELING, RouteKeys.COUNSELING_BY_USER_RETENTION),
	[RouteKeys.COUNSELING_BY_FEEDBACK]: fromIndex(SiderRouteFormat.COUNSELING, RouteKeys.COUNSELING_BY_FEEDBACK),
	[RouteKeys.COUNSELING_BY_VISIT_OUTCOME]: fromIndex(SiderRouteFormat.COUNSELING, RouteKeys.COUNSELING_BY_VISIT_OUTCOME),

	[RouteKeys.STRESS_USAGE_OVERVIEW]: fromIndex(SiderRouteFormat.STRESS, RouteKeys.STRESS_USAGE_OVERVIEW),
	[RouteKeys.STRESS_INDIVIDUAL_QUESTION]: fromIndex(SiderRouteFormat.STRESS, RouteKeys.STRESS_INDIVIDUAL_QUESTION),
	[RouteKeys.STRESS_BY_LEVEL]: fromIndex(SiderRouteFormat.STRESS, RouteKeys.STRESS_BY_LEVEL),
	[RouteKeys.STRESS_BY_AGE]: fromIndex(SiderRouteFormat.STRESS, RouteKeys.STRESS_BY_AGE),
	[RouteKeys.STRESS_BY_GENDER]: fromIndex(SiderRouteFormat.STRESS, RouteKeys.STRESS_BY_GENDER),
	[RouteKeys.STRESS_BY_RETURNING]: fromIndex(SiderRouteFormat.STRESS, RouteKeys.STRESS_BY_RETURNING),
    
	[RouteKeys.PEOPLE_OVERVIEW]: `${RouteKeys.REPORT}/${RouteKeys.PEOPLE}/${RouteKeys.PEOPLE_OVERVIEW}`,
	[RouteKeys.INDIVIDUAL_USER]: `${RouteKeys.REPORT}/${RouteKeys.PEOPLE}/${RouteKeys.INDIVIDUAL_USER}`,

	// [RouteKeys.PLAYGROUND]: RouteKeys.PLAYGROUND,
};
export default RouteKeys;


// WEBPACK FOOTER //
// ./src/constants/route.js